<template>
  <q-toolbar id="header" class="bg-black text-white">
    <router-link to="/" class="header-logo-link">
      <img src="@/assets/adti-wide.svg" alt="ATDI" class="header-logo">
    </router-link>

    <q-btn v-if="route.meta.backButton" flat label="Back" class="q-ml-md" @click="back" />

    <q-space />

    <q-btn v-if="session" flat :label="username" to="/account" />
    <q-btn v-if="!session && route.name !== 'login'" flat label="Login" to="/login" />
    <q-btn v-else-if="session && route.name !== 'login'" flat label="Logout" @click="logout" />
  </q-toolbar>
</template>

<script setup>
import { computed } from "vue"
import { useRoute, useRouter } from "vue-router"

import { useSessionStore } from "@/stores/userSession.js"

const route = useRoute()
const router = useRouter()
const sessionStore = useSessionStore()

const session = computed(() => sessionStore.session)

const username = computed(() => {
  const name = session.value?.username
  if (!name) return ""
  const at = name.indexOf("@")
  return at === -1 ? name : name.substring(0, at)
})

const logout = () => {
  sessionStore.removeSession()
  router.push({ name: "login" })
}

const back = () => {
  window.history.back()
}
</script>

<style lang="scss">
#header {
  z-index: 99;
}

.header-logo-link {
  display: inline-flex;
  align-items: center;
  height: 100%;
}

.header-logo {
  height: 36px;
}
</style>
